/*!
 * reconstruct v0.3.0
 * (c) 2018-present Vitor Luiz Cavalcanti <vitorluizc@outlook.com> (https://vitorluizc.github.io)
 * Released under the MIT License.
 */
import assign from 'object-assign';
/**
 * Get a collection of properties of an object.
 */

var keys = Object.keys;
/**
 * Reconstruct an Object into a new one composing lambda's returned objects.
 * @example ```js
 * reconstruct({ A: 1, B: 2 }, (value, key) => ({ [key]: value + 1 }))
 * //=> { A: 2, B: 3 }
 * ```
 * @param object Object that contains the properties and methods.
 * @param λ Lambda to reconstructs object.
 */

var reconstruct = function reconstruct(object, λ) {
  return keys(object).reduce(function (reconstruction, property) {
    var partial = λ(object[property], property, object);

    if (!partial) {
      return reconstruction;
    }

    return assign(reconstruction, partial);
  }, {});
};

export default reconstruct;